import React from 'react';
import DumbPrivacySettingButton from './dumpPrivacyButton';
import { KeyBoardAction } from './util';

const DumpSplashScreenBtnGroup = (props) => {
    const { continueViewText, validatorComponent, showPrivacySettingBtn, hilightColor = '#0076A8',
        useHyperLink, privacySettingBtnText, onClickPrivacySetting, onContinueView, showRejectAllBtn,
        rejectAllBtnText, onClickRejectAll } = props;

    if (validatorComponent) {
        return validatorComponent;
    }

    const onContinueViewKeyDown = (e) => {
        if (e.keyCode === KeyBoardAction.enter && onContinueView) {
            onContinueView(e);
        }
    };

    const onRejectAllKeydown = (e) => {
        if (e.keyCode === KeyBoardAction.enter) {
            onClickRejectAll(e);
        }
    };

    return (
        <div key="ContinueView" className="engagement-viewer-continue-view-container" >
            {
                showRejectAllBtn &&
                <div className="reject-all">
                    <button
                        className="enagement-buyer-btn engagement-buyer-btn-group"
                        onKeyDown={onRejectAllKeydown}
                        onClick={onClickRejectAll}
                        style={{ borderColor: hilightColor, color: hilightColor }}>
                        {rejectAllBtnText}
                    </button>
                </div>
            }
            <div className="settings-and-accept-btn-container">
                {
                    showPrivacySettingBtn &&
                    <div className="privacy-setting">
                        <DumbPrivacySettingButton
                            useHyperLink={useHyperLink}
                            text={privacySettingBtnText}
                            onClick={onClickPrivacySetting}
                            hilightColor={hilightColor} />
                    </div>

                }
                <div className="continue-button-container">
                    <button
                        style={{ backgroundColor: hilightColor }}
                        className="enagement-buyer-btn btn-active enagement-btn-continue-view"
                        onKeyDown={onContinueViewKeyDown}
                        onClick={onContinueView}>
                        {continueViewText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DumpSplashScreenBtnGroup;
